import { render, staticRenderFns } from "./ChangeViewBtn.vue?vue&type=template&id=0e5f4398&scoped=true&"
import script from "./ChangeViewBtn.vue?vue&type=script&lang=js&"
export * from "./ChangeViewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f4398",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QMenu,QList,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QMenu,QList,QItem,QItemSection}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
